import Yup from '@common/utils/yup'

export const formFieldsValidation = Yup.object().shape({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  email: Yup.string().email().required(),
  phone: Yup.string().required().internationalPhone().required(),
})
